import React from "react";
import { Link } from "react-scroll";
import "./TopNav.css";
import MaiyelanLogo1 from "../../assets/Images/outputLogo.png";

const TopNav = () => {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="home" smooth={true} duration={500} offset={-80}>
          <img style={{ width: '100px', height: '80px' }} src={MaiyelanLogo1} alt="Company Logo" />
        </Link>
        <p className="navbar-title">
          <span style={{ fontSize: '35px' }} className="maiyelan-text special-text">MAIYELAN</span>
          <br />
          <span className="exports-text special-text">EXPORTS</span>
        </p>
      </div>
      
      <ul className="navbar-links">
        <li>
          <Link to="home" smooth={true} duration={300} offset={-80} className="nav-link">HOME</Link>
        </li>
        <li>
          <Link to="aboutUs" smooth={true} duration={300} offset={-80} className="nav-link">ABOUT US</Link>
        </li>
        <li>
          <Link to="ourServices" smooth={true} duration={300} offset={-80} className="nav-link">OUR SERVICES</Link>
        </li>
        <li>
          <Link to="products" smooth={true} duration={300} offset={-80} className="nav-link">PRODUCTS</Link>
        </li>
        <li>
          <Link to="contactus" smooth={true} duration={300} offset={-80} className="nav-link">CONTACT US</Link>
        </li>
      </ul>
    </nav>
  );
};

export default TopNav;
